import styled from "styled-components"

export const AnimationSybTitle = styled.div`
  .swiper-slide-active h2 {
    animation: title 2s linear;
  }
  @keyframes title {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`
export const AnimationSybTitle1 = styled.div`
  .swiper-slide-active h2 {
    animation: title1 2s linear;
  }
  @keyframes title1 {
    0% {
      opacity: 0;
      transform: translateY(100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`
export const AnimationTitle = styled.div`
  .swiper-slide-active h1 {
    animation: title 1s linear;
  }
  @keyframes title {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`
export const AnimationItem = styled.div`
.swiper-slide-active .item {
  animation: item 1s linear;
}
@keyframes item {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
`
export const AnimationHeader = styled.div`
.header {
  padding-top: 20px;
  animation: header 1s linear;
}
@keyframes header {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
`
export const AnimationDown = styled.div`
.swiper-slide-active .down {
  animation: text 2s linear;
}
@keyframes text {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
`
export const AnimationDownImage = styled.div`
.swiper-slide-active img {
  animation: image 2s infinite;
}
@keyframes image {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  50% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}
`
export const AnimationLogo = styled.div`
.swiper-slide-active .logo {
  animation: logo 1s linear;
}
@keyframes logo {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
`